import { defineStore } from 'pinia'
import * as DataService from '@/DataService.js'

export const basketballStore = defineStore('basketball', {
    state: () => ({
        format: 'ddd M/DD/YYYY h:mm:ssa',
        todaysGames: [],
        gamesOnNow: [],
        lastUpdate: null,
        teams: [],
        teamsAndConfs: [],
        selectedSeason: 2025,
        selectedTeam: 'UVM',
        selectedConference: null,
        selectedPlayer: null,
        selectedTopPerformerTeam: null
    }),
    actions: {
        setConferenceOnSession(id) {
            // DataService.client.post(`/api/set-conference/${id}`);
        },
        getCurrentSeason() {
            DataService.client.get('/api/current-basketball-season')
            .then(d => {
                this.selectedSeason=d.data;
            });
        },

        // getConferences() {
        //     DataService.client.get('/bb-conferences')
        //     .then(d => {
        //         this.conferences=d.data;
        //     });
        // },
        // getTeams() {
        //     DataService.client.get(`teams`).then((d) => {
        //             this.mbbTeams=d.data;
        //         }
        //     );
        // },
        teamToNCAA(team){
            switch(team.toUpperCase()) {
                case 'ALBNY':
                    return 'ALBANY';
                case 'MASLOW':
                    return 'UMASSL';
                case 'BING':
                    return 'BINGHA';
                case 'VERM':
                    return 'VERMNT';
                case 'NHAMP':
                    return 'UNH';
                //njit umbc bryant maine
                default:
                    return team.toUpperCase();
            }
        }

    }
});
